import { useCrossFiltersStore } from '../stores/crossFilters';

export function useCrossFilters() {
  const rest = useCrossFiltersStore();
  return {
    ...rest,
    allActiveCrossFilters: Object.values(rest.crossFilters),
    allEnabledCrossFilters: Object.values(rest.filterKeys),
  };
}
